import React from 'react'

import ReturnsIconMedium from './ReturnsIconMedium'
import ReturnsIconSmall from './ReturnsIconSmall'
import { DynamicIconProps } from '../../../../types'

const ReturnsIcon: React.FC<DynamicIconProps> = ({ size = 'medium', ...props }) =>
  size === 'medium' ? <ReturnsIconMedium {...props} /> : <ReturnsIconSmall {...props} />

export default ReturnsIcon
